import { MEMBER_ERRORS } from "../member/member-errors.js";

export const REPORT_ERRORS = {
	TARGET_NOT_FOUND: "report_target_not_found",
	CANNOT_REPORT_OWN: "cannot_report_own_content",
	ALREADY_REPORTED: "already_reported",
	REPORT_NOT_FOUND: "report_not_found",
	REPORT_ALREADY_RESOLVED: "report_already_resolved",
	CANNOT_BAN_OWNER: "cannot_ban_owner",
	MEMBER_NOT_FOUND: MEMBER_ERRORS.NOT_FOUND,
	INVALID_ACTION_FOR_TARGET: "invalid_action_for_target",
} as const;

export type ReportErrorCode = (typeof REPORT_ERRORS)[keyof typeof REPORT_ERRORS];
